/**
 * Notifications 通知页面翻译
 */

import type { TranslationDict } from '../types';

export const notifications: TranslationDict = {
  pageTitle: {
    en: 'Notifications',
    'zh-CN': '通知',
    ja: '通知',
  },
  unreadCount: {
    en: '{{count}} unread',
    'zh-CN': '{{count}} 条未读',
    ja: '未読 {{count}} 件',
  },
  markAllRead: {
    en: 'Mark all read',
    'zh-CN': '全部已读',
    ja: 'すべて既読にする',
  },
  filters: {
    all: {
      en: 'All',
      'zh-CN': '全部',
      ja: 'すべて',
    },
    mentions: {
      en: 'Mentions',
      'zh-CN': '提及',
      ja: 'メンション',
    },
    follows: {
      en: 'Follows',
      'zh-CN': '关注',
      ja: 'フォロー',
    },
    system: {
      en: 'System',
      'zh-CN': '系统',
      ja: 'システム',
    },
  },
  types: {
    like: {
      en: 'liked your post',
      'zh-CN': '赞了你的帖子',
      ja: 'あなたの投稿にいいねしました',
    },
    comment: {
      en: 'commented on your post',
      'zh-CN': '评论了你的帖子',
      ja: 'あなたの投稿にコメントしました',
    },
    follow: {
      en: 'followed you',
      'zh-CN': '关注了你',
      ja: 'あなたをフォローしました',
    },
    mention: {
      en: 'mentioned you',
      'zh-CN': '提到了你',
      ja: 'あなたにメンションしました',
    },
    repost: {
      en: 'reposted your post',
      'zh-CN': '转发了你的帖子',
      ja: 'あなたの投稿をリポストしました',
    },
    system: {
      en: 'System notification',
      'zh-CN': '系统通知',
      ja: 'システム通知',
    },
  },
  time: {
    justNow: {
      en: 'just now',
      'zh-CN': '刚刚',
      ja: 'たった今',
    },
    minute: {
      en: 'm',
      'zh-CN': '分钟',
      ja: '分',
    },
    hour: {
      en: 'h',
      'zh-CN': '小时',
      ja: '時間',
    },
    day: {
      en: 'd',
      'zh-CN': '天',
      ja: '日',
    },
  },
  loadMore: {
    en: 'Load more',
    'zh-CN': '加载更多',
    ja: 'もっと見る',
  },
  dismiss: {
    en: 'Dismiss notification',
    'zh-CN': '忽略通知',
    ja: '通知を閉じる',
  },
  empty: {
    all: {
      title: {
        en: 'No notifications',
        'zh-CN': '暂无通知',
        ja: '通知はありません',
      },
      description: {
        en: "You're all caught up!",
        'zh-CN': '暂时没有新通知',
        ja: 'すべてチェック済みです！',
      },
    },
    mentions: {
      title: {
        en: 'No mentions',
        'zh-CN': '暂无提及',
        ja: 'メンションはありません',
      },
      description: {
        en: 'When someone mentions you, it will appear here.',
        'zh-CN': '当有人提到你时，会显示在这里',
        ja: '誰かがあなたにメンションすると、ここに表示されます',
      },
    },
    follows: {
      title: {
        en: 'No new followers',
        'zh-CN': '暂无新关注',
        ja: '新しいフォロワーはいません',
      },
      description: {
        en: 'When someone follows you, it will appear here.',
        'zh-CN': '当有人关注你时，会显示在这里',
        ja: '誰かがあなたをフォローすると、ここに表示されます',
      },
    },
    system: {
      title: {
        en: 'No system notifications',
        'zh-CN': '暂无系统通知',
        ja: 'システム通知はありません',
      },
      description: {
        en: 'Important updates and announcements will appear here.',
        'zh-CN': '重要更新和公告会显示在这里',
        ja: '重要なアップデートやお知らせはここに表示されます',
      },
    },
  },
};
